<div>
  <h6 class="odx-title-6" i18n="@@global.wires">Leitungen</h6>

  <app-floorplan-menu-item-buttons>
    <app-add-button
      (add)="addWire()"
      [odxTooltip]="tooltipTextAddWire"
      [odxTooltipOptions]="{ position: 'bottom' }"
      (dragStart)="dragWire()"
    ></app-add-button>
    <app-toggle-visibility-button [visible]="floorplanState.wiresVisible" (toggleEvent)="floorplanState.wiresVisible = $event">
    </app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.wiresItemTextVisible"
      (toggleEvent)="updateWiresItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button [locked]="floorplanState.wiresLocked" (toggleEvent)="floorplanState.wiresLocked = $event">
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
